import React from "react";
import ReactDOM from "react-dom";
import FenderProductGallery from "./components/FenderProductGallery/FenderProductGallery";

const reactElement = document.getElementById('fender-react');

ReactDOM.render(
  <FenderProductGallery />,
  reactElement
);
